module.exports = __webpack_public_path__ + "img/reaction10.a74ee269.png";